import {
  bignumberDependencies,
  create,
  divideDependencies,
  equalDependencies,
  formatDependencies,
  multiplyDependencies,
  roundDependencies,
} from "mathjs"

const math = create({
  bignumberDependencies,
  multiplyDependencies,
  divideDependencies,
  formatDependencies,
  equalDependencies,
  roundDependencies,
}, {})

export default math
